import React from "react";
import "./NewsPopup.css";
import { useTranslation } from "react-i18next";
import fallbackImg from "../../../assets/images/fallback.png";

function NewsPopup({ news, onClose }) {
  const { t, i18n } = useTranslation("home");
  if (!news) return null;

  return (
    <div className="news-popup-overlay" onClick={onClose}>
      <div className="news-popup" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>
          ✕
        </button>

        <img src={news.image_url || fallbackImg} alt={news.title} />

        <h2>{news.title?.[i18n.language.toLocaleLowerCase()]}</h2>

        <p>{news.content?.[i18n.language.toLocaleLowerCase()]}</p>

        <span>{news.created_at}</span>
      </div>
    </div>
  );
}

export default NewsPopup;
